import React from "react";
import TitleFormat from "../../../components/TitleFormat";
import BannerType1 from "../../../components/BannerType1";
import DesignGalleryContent from "./DesignGalleryContent";
import { useTranslation } from "react-i18next";
import { Seo } from "../../../components/Seo";

const DesignGallery = () => {
  const { t } = useTranslation();
  return (
    <>
      <Seo title={t("design.gallery.seo.title")} description={t("design.gallery.seo.des")} path="design/gallery" />
      <TitleFormat text={t("design.gallery.title")} />
      <BannerType1 path="/imgs/banner_design_gallery.png" />
      <DesignGalleryContent />
    </>
  );
};

export default DesignGallery;
